export default "/images/vendor/flag-icons/flags/4x3/id.svg?f624e2c8444a7794b35736c30dd82dda";